import { useRef, useState } from "react";
import { API } from "@/lib/api";
import { Loader2, Upload, X, FileText } from "lucide-react";
import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function FileUploader({ files, setFiles, single = false, label = "Anexar fotos ou desenhos (JPG, PNG, PDF)" }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);

  const onPick = async (e) => {
    const list = Array.from(e.target.files || []);
    if (!list.length) return;
    setBusy(true);
    const uploaded = [];
    for (const f of list) {
      try {
        const fd = new FormData();
        fd.append("file", f);
        const res = await fetch(`${API}/upload`, { method: "POST", body: fd });
        if (!res.ok) throw new Error();
        const data = await res.json();
        uploaded.push({ url: data.url, name: data.filename });
      } catch { toast.error(`Falha ao enviar ${f.name}`); }
    }
    setFiles(single ? uploaded.slice(-1) : (prev) => [...prev, ...uploaded]);
    setBusy(false);
    if (ref.current) ref.current.value = "";
  };

  const remove = (i) => setFiles((prev) => prev.filter((_, idx) => idx !== i));

  return (
    <div>
      <button type="button" data-testid="file-upload-trigger" onClick={() => ref.current?.click()} disabled={busy}
        className="flex w-full items-center justify-center gap-2 border border-dashed border-[#3f3f46] bg-[#0A0A0B] px-4 py-6 text-sm text-[#A1A1AA] transition-colors duration-200 hover:border-[#FF5500]">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />} {label}
      </button>
      <input ref={ref} type="file" accept=".jpg,.jpeg,.png,.webp,.pdf" multiple={!single} className="hidden" onChange={onPick} data-testid="file-upload-input" />
      {files.length > 0 && (
        <ul className="mt-3 space-y-2">
          {files.map((f, i) => (
            <li key={i} className="flex items-center justify-between border border-[#27272A] bg-[#0A0A0B] px-3 py-2 text-sm">
              <a href={f.url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 truncate text-[#A1A1AA] hover:text-white"><FileText className="h-4 w-4 shrink-0" />{f.name}</a>
              <button type="button" onClick={() => remove(i)} data-testid={`file-remove-${i}`}><X className="h-4 w-4 text-[#71717A] hover:text-red-400" /></button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
